import { useContext } from 'react';
import { CreateProjectContext, SKILL_OPTIONS, SkillType } from './consts';
import { Button, MultiSelectDropdown } from '@platform/components';
import { ROUTES } from '../routes/consts';
import { useForm } from 'react-hook-form';
import { navigate } from 'wouter/use-browser-location';

type FormValues = {
  values: SkillType[];
};

const SkillsStep = () => {
  const { skills, setSkills } = useContext(CreateProjectContext);

  const { handleSubmit, setValue, watch, register } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: { values: Array.from(skills) },
  });

  const onSelectionChange = (value: string[]) => {
    setValue('values', value as SkillType[]);
  };

  const onSavePressed = handleSubmit((data) => {
    const newSkills = new Set(data.values);
    setSkills(newSkills);
    navigate(`/platform${ROUTES.CREATE_PROJECT}/3`);
  });

  return (
    <>
      <div className='text-center'>
        <div>What skills would this person need to support you?</div>
        <div>Please choose 3-5 skills that you're looking for in an experteer.</div>
      </div>
      <div className='bg-white p-4 w-2xl flex flex-col gap-4 items-center'>
        <MultiSelectDropdown
          register={() => {
            return register('values');
          }}
          selectedItems={watch('values') || []}
          onSelectionChange={onSelectionChange}
          options={SKILL_OPTIONS}
          placeholder='Select skills'
          selectionLimit={5}
          filterable
        />
        {/* TODO: Should only save skills upon clicking this button */}
        <div className='w-fit'>
          {/*<Link to={`${ROUTES.CREATE_PROJECT}/3`} asChild>*/}
          <Button
            onPress={(_e) => onSavePressed()}
            type='submit'
            variant='accent'
            size='lg'
            isDisabled={watch('values').length === 0}
          >
            Save and continue
          </Button>
          {/*</Link>*/}
        </div>
      </div>
    </>
  );
};

export default SkillsStep;
